import React from "react";
import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import Lottie from "lottie-react";
import { prefersReducedMotion } from "../utility/motion";

interface SimpleCardProps {
  src: any;
  title: string;
  text: string;
}

export default function SimpleCard(props: SimpleCardProps) {
    return (
        <div className="simple-card">
            <Card className="bg-transparent">
                <div className="w-36 h-36 overflow-hidden mx-auto flex items-center justify-center">
                    <Lottie
                        loop={!prefersReducedMotion}
                        autoplay={true}
                        animationData={props.src}
                        rendererSettings={{
                            preserveAspectRatio: "xMidYMid slice"
                        }}
                        className='card-img'
                    />
                </div>
                <CardBody>
                    <h3 className="card-title-1 pb-7">{props.title}</h3>
                    <p className="card-description">
                        {props.text}
                    </p>
                </CardBody>
            </Card>
        </div>
    );
}
